export enum TRANSACTION_STATUS_ERROR_MESSAGES {
  TRANSACTION_STATUS_UNKNOWN = 'Transaction is unknown.',
  TRANSACTION_STATUS_SUCCESSFUL_ROLLBACK = 'Transaction was rollback.',
  TRANSACTION_STATUS_FAILED = `Transaction failed.`,
}
